import { differenceInMonths, startOfToday } from "date-fns";
import { SpeciesEnum } from "../../__generated__/globalTypes";
import { getCampaigns } from "./site";

// if the animal is younger than 17 weeks, it is eligible for a puppy discount
export const getYoungAnimalDiscount = ({
  birthday,
  species,
}: {
  birthday?: string | null;
  species: SpeciesEnum | null | undefined;
}) => {
  const campaigns = getCampaigns();

  if (!birthday) {
    return;
  }

  const months = differenceInMonths(startOfToday(), new Date(birthday));

  if (months >= 6) {
    return;
  }

  if (species === SpeciesEnum.dog) {
    return campaigns?.puppy;
  }

  if (species === SpeciesEnum.cat) {
    return campaigns?.kitten;
  }
};
